import React from "react";
import { useDroppable } from "@dnd-kit/core";
import styled from "styled-components";
import { color } from "style/constants";

interface DroppableProps {
  id: string;
  label: string;
  children: React.ReactNode;
  isDropped: boolean;
}

const Droppable: React.FC<DroppableProps> = ({ id, label, children, isDropped }) => {
  const { isOver, setNodeRef } = useDroppable({
    id
  });

  return (
    <StyledDiv ref={setNodeRef} isOver={isOver} isDropped={isDropped}>
      <ContentWrapper>
        {label}
        <Separator />
        <ButtonsContainer>{children}</ButtonsContainer>
      </ContentWrapper>
    </StyledDiv>
  );
};

const StyledDiv = styled.div<{ isOver: boolean; isDropped: boolean }>`
  background-color: ${props => (props.isOver ? color.LIGHTBLUE : "undefined")};
  border: ${props => {
    if (props.isOver) {
      return `1px solid ${color.DARKBLUE}`;
    } else if (props.isDropped) {
      return `1px solid ${color.BLACK}`;
    } else {
      return `1px dashed ${color.BLACK}`;
    }
  }};
  border-radius: 8px;
  display: flex;
  min-height: 111px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  transition: background-color 0.3s, border 0.3s;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContentWrapper = styled.div`
  width: 100%;
`;

const Separator = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${color.DARKERGRAY};
  margin: 8px 0;
`;

export default Droppable;
